import { MdErrorOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { Button } from "components/button";

import styles from "./index.module.css";

export const ErrorOverlay = ({ onRetry }: { onRetry: () => void }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <MdErrorOutline size={62} />
        <h1 className={styles.title}>Something went wrong</h1>
        <div className={styles.divider} />
        <p className={styles.description}>
          We encountered an error while loading your call script. This might be a temporary issue.
          Please try again or go back to select a different call script.
        </p>
        <div className={styles.buttonGroup}>
          <Button className={styles.actionButton} onClick={onRetry} variant="dark-gradient">
            Try Again
          </Button>
          <Button className={styles.actionButton} onClick={() => navigate(-1)} variant="primary">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};
